/** Scoped ink theme for the order date pickers. Other MUI controls stay on the default theme. */
import { createTheme } from '@mui/material/styles';

const INK = '#0a0a0a';

export const pickerTheme = createTheme({
  palette: { primary: { main: INK }, text: { primary: '#111827', secondary: '#6b7280' } },
  typography: { fontFamily: 'var(--font)' },
  shape: { borderRadius: 10 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid rgba(0,0,0,0.08)',
          boxShadow: '0 12px 28px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: { backgroundColor: 'rgba(10,10,10,0.45)', backdropFilter: 'blur(4px)' },
      },
    },
    MuiDateCalendar: { styleOverrides: { root: { height: 'auto', maxHeight: 'none' } } },
    MuiPickersSlideTransition: { styleOverrides: { root: { minHeight: 232 } } },
    MuiPickersCalendarHeader: {
      styleOverrides: { label: { fontWeight: 600, letterSpacing: '-0.01em' } },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase',
          letterSpacing: '0.04em', color: '#6b7280',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          transition: 'background-color 150ms ease, transform 100ms ease-out',
          '&:hover': { backgroundColor: '#eef0f3' },
          '&:active': { transform: 'scale(0.94)' },
          '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus': {
            backgroundColor: INK, color: '#fff', fontWeight: 600,
          },
          '&.MuiPickersDay-today:not(.Mui-selected)': { border: `1px solid ${INK}` },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 10 },
        textPrimary: { color: INK, '&:hover': { backgroundColor: '#f1f2f4' } },
      },
    },
    MuiIconButton: {
      styleOverrides: { root: { '&:hover': { backgroundColor: '#f1f2f4' } } },
    },
  },
});
